import React from "react";
import BaseModal from "./BaseModal";
import Form from "../form/Form";
import {fillProperties} from "../../Utility";

const FormModal = ({item, isOpen, onCancel, onSubmit }) => {
    const{data,schema,status,error} = item.formData;
    const initialData = fillProperties(data, item.row);
    const formSubmitHandler = (data) => {
        onSubmit(data);
    }
    const formCancelHandler = () => {
        onCancel();
    }
    return (
        <BaseModal isOpen={isOpen}>
            <div className="modal-body p-5 mb-n2">
                <h5 className="modal-title mb-4">{item.formTitle}</h5>
                <Form onFormSubmit={formSubmitHandler}
                      onFormCancel={formCancelHandler}
                      schema={schema}
                      initialData={initialData}
                      status={status}
                      error={error}/>
            </div>
        </BaseModal>
    );
}

export default FormModal;
